export default {
    MIN_LENGTH: 15000, // MIN / MAX Length Values were provided by the API to use
    MAX_LENGTH: 300000,
    COURSE_TYPE: ['road_biking', 'mountain_biking', 'gravel_cycling'],
    RANGE_TOLERANCE: 0.00001 // the algorithm can output values that are close but not exactly equal, if the difference is < .00001 they are equal
};
